import { StrictMode, Suspense, useEffect } from 'react'

import { CssBaseline } from '@mui/material'

import createLogger from '~/src/Lib/Logging'
import { isNativePlatform } from '~/src/Native/platform'
import { isSolusOnlyDevOverride } from '~/src/Native/solus/dev'
import { PUBLIC_ROUTES } from '~/src/Routes/constants'
import { useConnectModern } from '~/src/Store/hooks/useConnectModern'

import { lazyWithRetries } from '../Lib/Utils'
import Public from './Public'
import { fallbackContent } from './utils'

const Authenticated = lazyWithRetries(() => import('./Authenticated'))
const SolusOnly = lazyWithRetries(() => import('./SolusOnly'))

const logger = createLogger('App/Main')
const HOME_ROUTE = '/'

const Main = () => {
  const {
    appIsReady,
    auth,
    routeInfo = {},
    doUpdateUrl,
  } = useConnectModern('selectAppIsReady', 'selectAuth', 'selectRouteInfo', 'doUpdateUrl')
  const { pattern = HOME_ROUTE, value: route } = routeInfo
  const { authenticated } = auth
  const solusOnly = authenticated && (isSolusOnlyDevOverride() || (isNativePlatform() && auth.solusOnly === true))

  useEffect(() => {
    if (solusOnly && pattern !== HOME_ROUTE) {
      logger.debug(`solus-only user, redirecting to ${HOME_ROUTE}`)
      doUpdateUrl(HOME_ROUTE)
    } else if (!authenticated && pattern === HOME_ROUTE) {
      logger.debug(`not authenticated, redirecting from ${HOME_ROUTE} to ${PUBLIC_ROUTES.LOGIN}`)
      doUpdateUrl(PUBLIC_ROUTES.LOGIN)
    }
  }, [authenticated, doUpdateUrl, pattern, solusOnly])

  const Component = solusOnly ? SolusOnly : appIsReady && route && !route.publicAccess ? Authenticated : Public
  const componentName = solusOnly
    ? 'SolusOnly'
    : appIsReady && route && !route.publicAccess
      ? 'Authenticated'
      : 'Public'
  logger.debug(`returning ${componentName} entry component`)
  return (
    <StrictMode>
      <Suspense fallback={fallbackContent}>
        <CssBaseline />
        <Component />
      </Suspense>
    </StrictMode>
  )
}

export default Main
